import DataSource from "devextreme/data/data_source";
export enum AzioniFirDigitaliEnum {
  Trasporto = 'Trasporto',
  TrasportoUpdate = 'TrasportoUpdate',
  DatiQuantita = 'DatiQuantita',
  DatiQuantitaUpdate = 'DatiQuantitaUpdate',
  Accettazione = 'Accettazione',
  Allegato = 'Allegato',
  Annotazione = 'Annotazione',
  Reset = 'Reset',
  Rilascia = 'Rilascia',
  Annulla = 'Annulla',
  NoteAnnullamento = 'NoteAnnullamento',
  Hash = 'Hash',
  TrasbordoTotale = 'TrasbordoTotale',
  TrasbordoParziale = 'TrasbordoParziale',
  SostaTecnica = 'SostaTecnica',
  NuovoDestinatario = 'NuovoDestinatario',
  AcquisizioneFirma = 'AcquisizioneFirma',
  AcquisizioneFirmaAnnullamento = 'AcquisizioneFirmaAnnullamento',
  AcquisizioneFirmaTrasportatore = 'AcquisizioneFirmaTrasportatore',
  AcquisizioneFirmaProduttore = 'AcquisizioneFirmaProduttore',
  AcquisizioneFirmaProduttoreTrasportatore = 'AcquisizioneFirmaProduttoreTrasportatore',
  AcquisizioneFirmaDestinatario = 'AcquisizioneFirmaDestinatario',
  AcquisizioneFirmaAnnotazione = 'AcquisizioneFirmaAnnotazione',
  AcquisizioneFirmaTrasbordoTotale = 'AcquisizioneFirmaTrasbordoTotale',
  AcquisizioneFirmaSostaTecnica = 'AcquisizioneFirmaSostaTecnica',
  AcquisizioneFirmaTrasbordoParziale = 'AcquisizioneFirmaTrasbordoParziale',
  AcquisizioneFirmaDestinatarioSuccessivo = 'AcquisizioneFirmaDestinatarioSuccessivo',
  AcquisizioneFirmaAccettazioneSuccessiva = 'AcquisizioneFirmaAccettazioneSuccessiva',
  RollbackFirma = 'RollbackFirma',
}
export type AzioniFirDigitaliKey = keyof typeof AzioniFirDigitaliEnum;
export enum StatiFirDigitaliEnum {
  InserimentoQuantita = 'InserimentoQuantita',
  InserimentoQuantitaTrasportoIniziale = 'InserimentoQuantitaTrasportoIniziale',
  InserimentoTrasportoIniziale = 'InserimentoTrasportoIniziale',
  FirmaProduttoreTrasportatoreIniziale = 'FirmaProduttoreTrasportatoreIniziale',
  FirmaTrasportatoreIniziale = 'FirmaTrasportatoreIniziale',
  FirmaProduttore = 'FirmaProduttore',
  InserimentoTrasportoSuccessivo = 'InserimentoTrasportoSuccessivo',
  FirmaTrasportatoreSuccessivo = 'FirmaTrasportatoreSuccessivo',
  FirmaAnnotazione = 'FirmaAnnotazione',
  FirmaTrasbordoParziale = 'FirmaTrasbordoParziale',
  FirmaTrasbordoTotale = 'FirmaTrasbordoTotale',
  FirmaSostaTecnica = 'FirmaSostaTecnica',
  // FirmaAllegato = 'FirmaAllegato',
  InserimentoAccettazione = 'InserimentoAccettazione',
  FirmaAccettazione = 'FirmaAccettazione',
  Accettato = 'Accettato',
  RespintoAccettatoParzialmente = 'RespintoAccettatoParzialmente',
  FirmaDestinatarioSuccessivo = 'FirmaDestinatarioSuccessivo',
  FirmaAccettazioneSuccessiva = 'FirmaAccettazioneSuccessiva',
  FirmaAnnullamento = 'FirmaAnnullamento',
  Annullato = 'Annullato',
  Indeterminato = 'Indeterminato',
}

export interface FirStore {
  filtriAvanzati: { local: Record<string, any>, remote: Record<string, any> },
  soggetto: number
  filtro: string
  tipo: number
}

export interface Pager {
  isStartPage: boolean;
  isEndPage: boolean;
  totalCount: number;
  pageSize: number;
  totalPages: number;
  pages: (number | string)[];
  pageIndex: number;
}

export interface SelectData {
  produttore: DataSource | [],
  soggetto: DataSource | [],
  trasportatore: DataSource | [],
  destinatario: DataSource | [],
  blocco_fir: DataSource | [],
  autisti: DataSource | [],
  targhe: DataSource | [],
  tipo: { valueExpr: number, displayExpr: string }[],
  eer: DataSource,
  azienda: DataSource,
}


export interface PostFirDigitale {
  num_iscr_sito: string; // pattern: ^OP[0-9]{4}[A-Z0-9]{3}[0-9]{6}-[A-Z]{2}[0-9]{4}$

  dati_partenza: DatiPartenza;
  dati_trasporto_partenza: DatiTrasportoTerrestre;
}

/* ---------------------------------------------------------
   DATI PARTENZA
--------------------------------------------------------- */
export interface DatiPartenza {
  numero_fir: string | null;

  produttore: DatiProduttore | null;
  destinatario: DatiDestinatario;

  trasportatori: DatiTrasportatore[];
  intermediari: Intermediario[] | null;

  rifiuto: DatiRifiuto;

  trasbordo_parziale_origine: TrasbordoParzialeOrigine | null;

  annotazioni: string | null;
}

/* ---------------------------------------------------------
   PRODUTTORE
--------------------------------------------------------- */
export interface DatiProduttore {
  denominazione: string;
  codice_fiscale: string;
  nazione_id: string | null;

  indirizzo: Indirizzo;
  luogo_produzione: Indirizzo | null;

  autorizzazione: Autorizzazione | null;

  detentore: boolean | null;
}

/* ---------------------------------------------------------
   DESTINATARIO
--------------------------------------------------------- */
export interface DatiDestinatario {
  denominazione: string;
  codice_fiscale: string;
  nazione_id: string | null;

  indirizzo: Indirizzo;

  autorizzazione: Autorizzazione | null;

  attivita:
  | "R1" | "R2" | "R3" | "R4" | "R5" | "R6" | "R7" | "R8" | "R9"
  | "R10" | "R11" | "R12" | "R13"
  | "D1" | "D2" | "D3" | "D4" | "D5" | "D6" | "D7" | "D8" | "D9"
  | "D10" | "D11" | "D12" | "D13" | "D14" | "D15"
  | null;

}

/* ---------------------------------------------------------
   TRASPORTATORE
--------------------------------------------------------- */
export interface DatiTrasportatore {
  denominazione: string;
  codice_fiscale: string;
  nazione_id: string | null;

  tipo_trasporto: "Terrestre" | "Ferroviario" | "Marittimo";

  numero_iscrizione_albo: string | null; // pattern: ^([A-Za-z]{2})/([0-9]{6})$
}

/* ---------------------------------------------------------
   INTERMEDIARI
--------------------------------------------------------- */
export interface Intermediario {
  denominazione: string;
  codice_fiscale: string;
  nazione_id: string | null;
  numero_iscrizione_albo: string | null;
}

/* ---------------------------------------------------------
   RIFIUTO
--------------------------------------------------------- */
export interface DatiRifiuto {
  codice_eer: string; // max 8 chars
  descrizione: string | null;
  provenienza: "U" | "S";

  caratteristiche_chimico_fisiche: string | null;

  caratteristiche_pericolo:
  | (
    | "HP01" | "HP02" | "HP03" | "HP04" | "HP05" | "HP06" | "HP07"
    | "HP08" | "HP09" | "HP10" | "HP11" | "HP12" | "HP13" | "HP14" | "HP15"
  )[]
  | null;

  stato_fisico: "SP" | "S" | "FP" | "L" | "VS";

  quantita: {
    valore: number;
    unita_misura: "kg" | "l";
  } | null;

  verificato_in_partenza: boolean | null;

  trasporto_adr: boolean | null;

  dati_adr: {
    numero_onu: string | null;
    classe: string | null;
    note: string | null;
  } | null;

  analisi_classificazione: {
    tipo: string | null;
    numero: string | null;
    data: string | null; // ISO 8601
  } | null;

  numero_colli: string | null;
  rinfusa: boolean | null;
}

/* ---------------------------------------------------------
   TRASBORDO PARZIALE ORIGINE
--------------------------------------------------------- */
export interface TrasbordoParzialeOrigine {
  numero_fir_origine: string;

  produttore_originario: {
    nazione_id: string | null;
    denominazione: string;
    codice_fiscale: string;
  };

  causale: string;
}

/* ---------------------------------------------------------
   INDIRIZZO (Comune o estero)
--------------------------------------------------------- */
export interface Indirizzo {
  citta: {
    comune_id?: string; // ISTAT
    nazione_id?: string; // ISTAT
    nome_citta?: string; // ISTAT
  };
  indirizzo: string;
  civico: string | null;
  cap: string | null;
}

/* ---------------------------------------------------------
   AUTORIZZAZIONE
--------------------------------------------------------- */
export interface Autorizzazione {
  numero: string | null;
  tipo:
  | "RecSmalArt208"
  | "RecSmalImpMobiliArt208"
  | "RicercaSperimentazione"
  | "AIA"
  | "RecProcSemplificata"
  | "OpBonifica"
  | "Straordinario"
  | "ComTrattamentoAcqueReflue"
  | "AutTrattamentoAcqueReflue"
  | null;
}

/* ---------------------------------------------------------
   TRASPORTO TERRESTRE
--------------------------------------------------------- */
export interface DatiTrasportoTerrestre {
  conducente: {
    nome: string;
    cognome: string;
  };

  targa_automezzo: string | null;
  targa_rimorchio: string | null;

  percorso: string | null;

  presa_in_carico_rimorchio_precedente: boolean | null;

  data_ora_inizio_trasporto: string; // ISO 8601 UTC
  annotazioni: string | null;
}

export interface Sede {
  id: number
  idSoggetto: number
  descrizioneSoggetto: string
  descrizione: string
  isProduttore: boolean
  isTrasportatore: boolean
  isDestinatario: boolean
  isIntermediario: boolean
  isSmaltitore: boolean
  tipoTrasporto: string
  indirizzo: string
  civico: string
  frazione: any
  comune: string
  cap: string
  siglaProvincia: string
  istatComune: string
  idRegione: string
  stato: string
  latidudine: any
  longitudine: any
  tipoPCE: any
  riferimentoEsterno: any
  nota: any
  nota1: any
  nota2: any
  nota3: any
  superficiePubblica: boolean
  appunti: any
  idCategoria: any
  descrizione_IdCategoria: any
  idTipo: any
  descrizione_IdTipo: any
  idZona: any
  descrizione_IdZona: any
  rappresentanteNome: any
  rappresentanteCognome: any
  elaboraMud: any
  rea: any
  cciiaa: any
  ateco: any
  mesiAttivita: number
  addetti: number
  tipoMud: any
  gestioneRaee: boolean
  gestioneImballaggi: boolean
  autodemolizione: boolean
  rottamazione: boolean
  frantumazione: boolean
  idSedeRentri: any
  idRegistroPredefinito: any
  codiceConou: any
  isCobat: boolean
  numeroIscrizioneAlbo: string
  protocolloAlbo: any
  dataIscrizioneAlbo: any
  isImpiantoMobile: boolean
  dataChiusuraImpiantoMobile: any
  nsAzienda: boolean
  versione: number
}


//! ------------------------------ FIR -------------------------------------
export interface FIR {
  id: number
  idCausale: number
  causale_Descrizione: string
  causale_Id_Operazione: string
  spurghi: boolean
  causale_Trasporto: string
  isCaricoAutomaticoRifiutiDaLavorazione: boolean
  idPosizioneRifiuto: number
  posizioneRifiuto_Descrizione: string
  idPosizioneCausale: number
  idTipoCarico: string
  idProvenienzaGiacenza: string
  idRentri: any
  idDocumentoRifiutiRicopiato: any
  idCliente: any
  cliente_Descrizione: any
  cliente_Codice_Fiscale: any
  rinfusa: boolean
  cliente_Indirizzo: any
  cliente_Civico: any
  cliente_Frazione: any
  cliente_Comune: any
  cliente_CAP: any
  cliente_SiglaProvincia: any
  cliente_IstatComune: any
  idContratto: any
  contratto_Descrizione: any
  idAddebito: any
  addebito_Descrizione: any
  dataRegistrazione: string
  oraRegistrazione: any
  numeroFormulario: string
  dataFormulario: any
  idTipoFormulario: string
  numDocumentoInterno: string
  dataDocumentoInterno: any
  riferimentoDocumento: string
  scontrino: string
  idLotto: any
  idLotto_Sede: any
  lotto_Descrizione: any
  idProduttore: number
  isDetentore: any
  produttore_Id_Soggetto: number
  produttore_Descrizione_Soggetto: string
  produttore_Id_Regione_Soggetto: any
  produttore_Descrizione_Full: string
  produttore_Descrizione_Con_Indirizzo_Full: any
  produttore_Codice_Fiscale: string
  produttore_Id_Regione_Sede: any
  produttore_Indirizzo_Soggetto: any
  produttore_Civico_Soggetto: any
  produttore_Frazione_Soggetto: any
  produttore_Comune_Soggetto: any
  produttore_CAP_Soggetto: any
  produttore_SiglaProvincia_Soggetto: any
  produttore_IstatComune_Soggetto: any
  produttore_Indirizzo_Soggetto_Full: any
  produttore_Descrizione_Sede: string
  produttore_Indirizzo_Sede: string
  produttore_Civico_Sede: string
  produttore_Frazione_Sede: any
  produttore_Comune_Sede: string
  produttore_CAP_Sede: string
  produttore_SiglaProvincia_Sede: string
  produttore_IstatComune_Sede: string
  produttore_NumDataIscrizioneAlbo: any
  idMagazzinoProduttore: any
  magazzinoProduttore_Descrizione: any
  idAutorizzazioneProduttore: number
  autorizzazioneProduttore_Descrizione_Full: any
  autorizzazioneProduttore_Numero: string
  autorizzazioneProduttore_DataInizio: string
  autorizzazioneProduttore_DataFine: string
  autorizzazioneProduttore_Tipo: any
  autorizzazioneRentriProduttore_Id: any
  autorizzazioneRentriProduttore_Codice: any
  autorizzazioneRentriProduttore_Descrizione: any
  idProduttoreAlboCategoria: any
  produttoreAlboCategoria_Descrizione_Full: any
  idAutorizzazioneProduttoreArea: any
  autorizzazioneProduttoreArea_Descrizione: any
  produttore_Indirizzo_Civico_Sede: any
  produttore_IdCategoria_Sede: any
  produttore_IdCategoria_Soggetto: any
  produttore_IdTipo_Sede: any
  produttore_IdTipo_Soggetto: any
  produttore_IdZona_Sede: any
  produttore_IdZona_Soggetto: any
  produttore_Nostra_Azienda: any
  idCantiereFuoriUl: any
  cantiere_Descrizione: any
  cantiere_Descrizione_Full: any
  cantiere_Indirizzo: any
  cantiere_Civico: any
  cantiere_Frazione: any
  cantiere_Comune: any
  cantiere_CAP: any
  cantiere_SiglaProvincia: any
  cantiere_Descrizione_Con_Indirizzo_Full: any
  idTrasportatore: number
  trasportatore_Id_Soggetto: number
  trasportatore_Descrizione_Soggetto: string
  trasportatore_Descrizione_Full: string
  trasportatore_Id_Regione_Soggetto: any
  trasportatore_Codice_Fiscale: string
  trasportatore_Indirizzo_Soggetto: any
  trasportatore_Civico_Soggetto: any
  trasportatore_Frazione_Soggetto: any
  trasportatore_Comune_Soggetto: any
  trasportatore_CAP_Soggetto: any
  trasportatore_SiglaProvincia_Soggetto: any
  trasportatore_IstatComune_Soggetto: any
  trasportatore_Indirizzo_Soggetto_Full: any
  trasportatore_Descrizione_Sede: string
  trasportatore_Indirizzo_Sede: string
  trasportatore_Civico_Sede: string
  trasportatore_Frazione_Sede: any
  trasportatore_Comune_Sede: string
  trasportatore_CAP_Sede: string
  trasportatore_SiglaProvincia_Sede: string
  trasportatore_IstatComune_Sede: string
  trasportatore_NumDataIscrizioneAlbo: string
  trasportatore_Indirizzo_Civico_Sede: any
  trasportatore_Id_Regione_Sede: any
  trasportatore_Nostra_Azienda: any
  idTrasportatoreAlboCategoria: any
  autorizzazioneTrasportatoreAlbo_Full: any
  autorizzazioneTrasportatoreAlbo_DataInizio: any
  autorizzazioneTrasportatoreAlbo_DataFine: any
  trasportatore_IdCategoria_Sede: any
  trasportatore_IdCategoria_Soggetto: any
  trasportatore_IdTipo_Sede: any
  trasportatore_IdTipo_Soggetto: any
  trasportatore_IdZona_Sede: any
  trasportatore_IdZona_Soggetto: any
  autorizzazioneTrasportatore_DescrizioneCazzozzeriaMobileAutomezzo: any
  autorizzazioneTrasportatore_DescrizioneCazzozzeriaMobileRimorchio: any
  idAutista: any
  autista_Cognome: any
  autista_Nome: any
  autista_Cognome_Nome: string
  autista_Matricola: any
  autista_Descrizione_Full: any
  idOperatore1: any
  descrizione_Operatore_1: any
  idOperatore2: any
  descrizione_Operatore_2: any
  idAutomezzo: any
  automezzo_Descrizione: any
  automezzo_Descrizione_Full: any
  automezzo_Targa: any
  automezzo_TipoAutomezzo: any
  idRimorchio: any
  rimorchio_Descrizione: any
  rimorchio_Targa: any
  rimorchio_TipoAutomezzo: any
  rimorchio_Descrizione_Full: any
  idDestinatario: number
  destinatario_Id_Soggetto: number
  destinatario_Descrizione_Soggetto: string
  destinatario_Id_Regione_Soggetto: any
  destinatario_Descrizione_Full: string
  destinatario_Descrizione_Con_Indirizzo_Full: any
  destinatario_Codice_Fiscale: string
  destinatario_Indirizzo_Soggetto: any
  destinatario_Civico_Soggetto: any
  destinatario_Frazione_Soggetto: any
  destinatario_Comune_Soggetto: any
  destinatario_CAP_Soggetto: any
  destinatario_SiglaProvincia_Soggetto: any
  destinatario_Indirizzo_Soggetto_Full: any
  destinatario_IstatComune_Soggetto: any
  destinatario_Id_Regione_Sede: any
  destinatario_Descrizione_Sede: string
  destinatario_Indirizzo_Sede: string
  destinatario_Civico_Sede: string
  destinatario_Frazione_Sede: any
  destinatario_Comune_Sede: string
  destinatario_CAP_Sede: string
  destinatario_SiglaProvincia_Sede: string
  destinatario_IstatComune_Sede: string
  destinatario_Nostra_Azienda: any
  idAutorizzazioneDestinatario: number
  idAutorizzazioneDestinatarioArea: any
  autorizzazioneDestinatarioArea_Descrizione: any
  autorizzazioneDestinatario_Numero: string
  autorizzazioneDestinatario_Descrizione_Full: any
  autorizzazioneDestinatario_DataInizio: string
  autorizzazioneDestinatario_DataFine: string
  autorizzazioneRentriDestinatario_Id: any
  autorizzazioneRentriDestinatario_Codice: any
  autorizzazioneRentriDestinatario_Descrizione: any
  destinatario_IdCategoria_Sede: any
  destinatario_IdCategoria_Soggetto: any
  destinatario_IdTipo_Sede: any
  destinatario_IdTipo_Soggetto: any
  destinatario_IdZona_Sede: any
  destinatario_IdZona_Soggetto: any
  autorizzazioneDestinatario_Tipo: any
  destinatario_Indirizzo_Civico_Sede: any
  idOperazioneRD:
  | "R1" | "R2" | "R3" | "R4" | "R5" | "R6" | "R7" | "R8" | "R9"
  | "R10" | "R11" | "R12" | "R13"
  | "D1" | "D2" | "D3" | "D4" | "D5" | "D6" | "D7" | "D8" | "D9"
  | "D10" | "D11" | "D12" | "D13" | "D14" | "D15"
  | null;
  operazioneRecupero: any
  operazioneSmaltimento: any
  idMagazzinoDestinatario: number
  magazzinoDestinatario_Descrizione: string
  destinatario_Indirizzo_Deposito_Temporaneo_Spurghi: any
  destinatario_Comune_Deposito_Temporaneo_Spurghi: any
  listaInterventiSpurghi: any
  idIntermediario: any
  intermediario_Id_Soggetto: any
  intermediario_Descrizione_Soggetto: any
  intermediario_Id_Regione_Soggetto: any
  intermediario_Descrizione_Full: string
  intermediario_Codice_Fiscale: any
  intermediario_Indirizzo_Soggetto: any
  intermediario_Civico_Soggetto: any
  intermediario_Frazione_Soggetto: any
  intermediario_Comune_Soggetto: any
  intermediario_CAP_Soggetto: any
  intermediario_SiglaProvincia_Soggetto: any
  intermediario_IstatComune_Soggetto: any
  intermediario_Indirizzo_Soggetto_Full: any
  intermediario_Descrizione_Sede: any
  intermediario_Indirizzo_Sede: any
  intermediario_Civico_Sede: any
  intermediario_Frazione_Sede: any
  intermediario_Comune_Sede: any
  intermediario_CAP_Sede: any
  intermediario_SiglaProvincia_Sede: any
  intermediario_IstatComune_Sede: any
  intermediario_NumDataIscrizioneAlbo: string
  intermediario_Indirizzo_Civico_Sede: any
  intermediario_Id_Regione_Sede: any
  intermediario_Nostra_Azienda: any
  idIntermediarioAlboCategoria: any
  autorizzazioneIntermediarioAlbo_Full: string
  autorizzazioneIntermediarioAlbo_DataInizio: any
  autorizzazioneIntermediarioAlbo_DataFine: any
  intermediario_IdCategoria_Sede: any
  intermediario_IdCategoria_Soggetto: any
  intermediario_IdTipo_Sede: any
  intermediario_IdTipo_Soggetto: any
  intermediario_IdZona_Sede: any
  intermediario_IdZona_Soggetto: any
  eer: string
  eeR_Descrizione: any
  riferimentoEER: string
  idStatoFisico: string
  statoFisico_Descrizione: any
  statoFisico_Iniziali: any
  xSeSolidoPolverulento: any
  xSeSolidoNonPolverulento: any
  xSeFangosoPalabile: any
  xSeLiquido: any
  xSeAeriforme: any
  isCerPericoloso: boolean
  isUrbano: boolean
  quantitaOrigineKg: any
  unitaMisura: any
  verificatoPartenza: boolean
  xSeVerificatoPartenza: any
  xSeUnitaMisuraOrigineKg: any
  xSeUnitaMisuraOrigineLt: any
  quantita: any
  volume: any
  unitaMisuraVolume: string
  quantitaOrigineToPrint: any
  dataAccettazione: any
  oraAccettazione: any
  tipoAccettazione: string
  xSeAccettatoPerIntero: any
  xSeAccettatoParzialmente: any
  xSeRespinto: any
  daVerificareADestino: boolean
  xSeDaVerificareADestino: any
  quantitaRespinta: any
  idMotivoRespinta: any
  descrizioneRespinta: string
  xSeCausaleRespingimentoNC: any
  xSeCausaleRespingimentoIR: any
  xSeCausaleRespingimentoAltro: any
  idCategoriaDocumento: any
  categoriaDocumento_Descrizione: any
  idTipoDocumento: any
  tipoDocumento_Descrizione: any
  idZonaDocumento: any
  zonaDocumento_Descrizione: any
  idBacinoDocumento: any
  bacinoDocumento_Descrizione: any
  tipoDocumentoSpurghi: any
  tipoDocumentoSpurghi_Descrizione: any
  elencoHP: string
  listaHP: any[]
  caratteristiche_di_pericolo: string
  caratteristicheChimiche: string
  descrizioneAssegnata: string
  idRecup: any
  recup_Descrizione: any
  idBasilea: any
  bod: any
  cod: any
  analisiNumero: string
  analisiData: any
  analisiScadenza: any
  tipoAnalisi: string
  annotazioni: string
  dataInizioTrasporto: any
  oraInizioTrasporto: any
  dataFineTrasporto: any
  oraFineTrasporto: any
  idTestoADR: any
  testoADR_Descrizione: any
  adr: any
  idClasseAdr: any
  classeAdr_Descrizione: any
  idONU: any
  onU_Descrizione: any
  numeroColli: any
  idImballo: any
  imballo_Descrizione: any
  percorso: string
  dataLordoPesa: any
  oraLordoPesa: string
  mpLordoPesa: string
  kgLordoPesa: any
  dataTaraPesa: any
  oraTaraPesa: string
  mpTaraPesa: string
  kgTaraPesa: any
  idTipoRaee: string
  idCategoriaRaee: any
  categoriaRaee_Descrizione: any
  imballaggioRicevuto: string
  prodottoDaImballaggi: string
  isAlluminio: boolean
  idCausaleCobat: any
  causaleCobat_Descrizione: any
  idProdottoCobat: any
  prodottoCobat_Descrizione: any
  idCausaleConou: any
  causaleConou_Descrizione: any
  idProdottoConou: any
  prodottoConou_Descrizione: any
  percentualeConou: any
  operazioneVeicoliFuoriUso: any
  appunti: any
  idRegistroCarico: number
  idRegistroScarico: number
  idRegistroTrasporto: any
  idRegistroIntermediario: any
  idRegistroRentriCarico: any
  idRegistroRentriScarico: any
  idRegistroRentriTrasporto: any
  idRegistroRentriIntermediario: any
  registro_Descrizione_Carico: string
  registro_Descrizione_Scarico: string
  registro_Descrizione_Trasporto: any
  registro_Descrizione_Intermediario: any
  registro_Descrizione_Rentri_Carico: any
  registro_Descrizione_Rentri_Scarico: any
  registro_Descrizione_Rentri_Trasporto: any
  registro_Descrizione_Rentri_Intermediario: any
  protocollo: any
  protocolloCarico: any
  protocolloScarico: any
  protocolloTrasporto: any
  protocolloIntermediario: any
  protocolloGiacenzaIniziale: any
  annoGiacenzaIniziale: any
  idCaricoAutomatico: any
  caricoAutomatico_Descrizione: any
  listaCarichiDaAbbinare: any
  elencoProtocolliCarichiAbbinati: any
  xSeRecupero: any
  xSeSmaltimento: any
  xSeCarico: any
  xSeScarico: any
  xSeDT: any
  xSeNP: any
  xSeT: any
  xSeRE: any
  xSeI: any
  xSeaT: any
  xSeM: any
  xSeTR: any
  xSeUrbano: any
  xSeSpeciale: any
  xSeDetentore: any
  isGestioneRaee: boolean
  isGestioneImballaggioRicevuto: boolean
  isGestioneImballaggioProdotto: boolean
  isGestioneVeicoloFuoriUso: boolean
  isGestioneCantiere: boolean
  listaAltriSoggettiP: any
  listaAltriSoggettiT: any
  listaAltriSoggettiS: any
  listaAltriSoggettiI: any
  listaAltriSoggettiO: any
  idSchedaLavorazioni: any
  listaSchedeLavorazioni: any[]
  caricoDaMiscelazione: boolean
  listaMiscelazione: any[]
  attivaRintracciabilita: boolean
  listaTracciabilita: any[]
  qrCodeVivifir: any
  testoVidimazione1: any
  testoVidimazione2: any
  testoVidimazione3: any
  testoVidimazioneFull: any
  contatore: number
  idUserLock: any
  force: any
  versione: number
}
